import App from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"
import Director from "@frog/source/juice/Director.js"
import {loader} from "@frog/source/utility/canvas/gl/render.js"

import Stage from "@frog/source/views/Stage.view.js"
import Interface from "@frog/source/views/Interface.view.js"
import Particles from "@frog/source/views/Particles.view.js"
import Text from "@frog/source/views/Text.view.js"
import timer from "@frog/source/juice/utility/timer.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Ink from "@frog/source/utility/Ink.js"
import {getReferencedUnit, units} from "@frog/source/data/units.js"

export default function Root({stage} = {}) {
    if(loader.isPreloaded != true) {
        return {
            "key": "LoadingScreen",
            "width": "100%",
            "height": "100%",
            "_": [
                // {
                //     "key": "LoadingText",
                //     "image": require("@frog/source/assets/images/hero-tactics/ui/victory.png").default,
                //     "anchor": {"x": "50%"},
                //     "position": {"x": "50%", "y": 60 + "px"},
                // },
                {
                    "key": "LoadingBar",
                    "color": "#AAAAAA",
                    "height": 20,
                    "width": "66%",
                    "position": {"x": "50%", "y": "50%"},
                    "anchor": {"x": "50%", "y": "50%"},
                    // "left": 10,
                    // "right": 10,
                    // "bottom": 10,
                    // "height": 10,
                    "_": [
                        {
                            "width": Math.min(1, loader.count / loader.preload.length) * 100 + "%",
                            "height": 100 + "%",
                            "color": "#FFFFFF",
                        }
                    ]
                },
            ]
        }
    }

    stage = stage || App.getActiveStage()

    return {
        "key": "Root",
        "width": "100%",
        "height": "100%",
        "_": [
            Screen(stage),
        ],
    }
}

function Screen(stage) {
    if(Navigation.state.screen == "SplashScreen") {
        return SplashScreen(stage)
    }
    if(Navigation.state.screen == "TitleScreen") {
        return TitleScreen(stage)
    }
    if(Navigation.state.screen == "CreditsScreen") {
        return CreditsScreen(stage)
    }
    if(Navigation.state.screen == "ChapterSelectScreen") {
        return ChapterSelectScreen(stage)
    }
    if(Navigation.state.screen == "TownScreen") {
        return TownScreen(stage)
    }
    return CombatEncounterScreen(stage)
}

function Repeat(character, times) {
    let string = ""
    for(let i = 0; i < times; i += 1) {
        string += character
    }
    return string
}

function TownScreen() {
    App.game.encounter = App.game.encounter || {"stage": {}}
    return {
        "key": "TownScreen",
        "width": "100%",
        "height": "100%",
        "_": [
            TownStage(),
            Shop(),
            BackToFarmButton(),
            PlayerStatus(),
            Dialogue(App.game?.encounter?.sequence?.steps[0]?.stage),
        ]
    }
}

function PlayerStatus(stage) {
    return {
        "position": {
            "x": "100%",
            "y": 0,
        },
        "anchor": {
            "x": "100%",
        },
        "_": [
            Text({"text": "Your Harvested Crops: " + App.game.player.score}),
        ],
    }
}

function BackToFarmButton(stage) {
    if(Navigation.state.section != undefined) {
        return
    }
    return {
        "position": {
            "x": 0,
            "y": "100%",
        },
        "anchor": {
            "x": "0%",
            "y": "100%",
        },
        "_": [
            Text("Start another day on the farm?")
        ],
        "events": {
            "cursordown": (event) => {
                Navigation.go("/game/encounters/next_day")
            }
        },
        "color": "#e69633",
        "overrides": {
            "hovered": {
                "color": "#e6db33",
            },
        },
    }
}

import Dialogue from "@frog/source/views/Dialogue.view.js"
import pixel from "@frog/source/views/utility/pixel.js"
// import {getImageFromAnimation} from "@frog/source/juice/utility/getFrameFromAnimation.js"
import {getTime} from "@frog/source/juice/utility/Time.js"
import InkDialogue from "@frog/source/utility/InkDialogue.js"

function TownStage(stage) {
    const time = getTime().ms
    return {
        "width": "100%",
        "height": "100%",
        "position": {
            "y": 16,
        },
        "_": [
            {
                "image": require("@frog/source/assets/images/apocalypse-tactics/sewer.png").default,
            },
            Entity({
                "position": {"x": 11, "y": 1, "z": 0},
                "image": getImageFromAnimation(units["class:donna"].images.sprites["idle"], time),
                "onClick": function(event) {
                    if(App.getActiveStage().dialogue != undefined) return
                    Director.addEvents(App.game.encounter.stage, InkDialogue("donna.talk"))
                }
            }),
            Entity({
                "position": {"x": 11, "y": 0, "z": 0},
                "image": getImageFromAnimation(units["class:blitz"].images.sprites["idle"], time),
                "onClick": function(event) {
                    if(App.getActiveStage().dialogue != undefined) return
                    Director.addEvents(App.game.encounter.stage, InkDialogue("blitz.talk"))
                }
            }),
            Entity({
                "position": {"x": 10, "y": 3, "z": 0},
                "image": getImageFromAnimation(units["class:jasmine"].images.sprites["idle"], time),
                "onClick": function(event) {
                    if(App.getActiveStage().dialogue != undefined) return
                    Director.addEvents(App.game.encounter.stage, InkDialogue("jasmine.talk"))
                }
            }),
            Entity({
                "position": {"x": 6, "y": -1, "z": 0},
                "image": getImageFromAnimation(units["class:z"].images.sprites["idle"], time),
                "onClick": function(event) {
                    if(App.getActiveStage().dialogue != undefined) return
                    Director.addEvents(App.game.encounter.stage, InkDialogue("z.talk"))
                }
            }),
            Entity({
                "position": {"x": 8, "y": -2, "z": 0},
                "image": require("@frog/source/assets/images/apocalypse-tactics/units/chalk_standing.png").default,
                "onClick": function(event) {
                    if(App.getActiveStage().dialogue != undefined) return
                    Director.addEvents(App.game.encounter.stage, InkDialogue("chalk.talk"))
                }
            }),
            // Entity({
            //     "position": {"x": 9, "y": -1, "z": 0},
            //     "image": require("@frog/source/assets/images/apocalypse-tactics/environment/props/prop_ventilator.png").default,
            // }),
            Entity({
                "isFlipped": true,
                "position": {"x": 6, "y": 1, "z": 0},
                "image": require("@frog/source/assets/images/apocalypse-tactics/units/tsing_standing.png").default,
                "onClick": function(event) {
                    if(App.getActiveStage().dialogue != undefined) return
                    Director.addEvents(App.game.encounter.stage, InkDialogue("tsing.talk"))
                }
            }),
            Entity({
                "position": {"x": 6, "y": 0, "z": 0},
                "image": require("@frog/source/assets/images/apocalypse-tactics/environment/props/prop_tank_A.png").default,
                "onClick": function(event) {
                    if(App.getActiveStage().dialogue != undefined) return
                    Navigation.state.section = "shop"
                }
            }),
            Entity({
                "isFlipped": true,
                "position": {"x": 9, "y": 3, "z": 0},
                "image": require("@frog/source/assets/images/apocalypse-tactics/units/weylan_standing.png").default,
                "onClick": function(event) {
                    if(App.getActiveStage().dialogue != undefined) return
                    Director.addEvents(App.game.encounter.stage, InkDialogue("weylan.talk"))
                }
            }),
            // Entity({
            //     "hasLargeShadow": true,
            //     "position": {"x": 8, "y": 2, "z": 0},
            //     // "image": require("@frog/source/assets/images/apocalypse-tactics/environment/props/prop_tableTire_A.png").default,
            //     "image": require("@frog/source/assets/images/apocalypse-tactics/environment/props/prop_crate_A.png").default,
            // }),
        ]
    }
}

function Entity(unit) {
    return {
        "position": pixel("unit", unit.position),
        "_": [
            {
                // "color": "orange",
                "width": 32,
                "height": 64,
                "anchor": {"x": "50%", "y": "100%"},
                "position": {"x": 0, "y": 0},
                "events": {
                    "cursordown": (event) => {
                        if(unit.onClick != undefined
                        && Navigation.state.section == undefined) {
                            unit.onClick()
                        }
                    }
                },
            },
            {
                "key": "Shadow",
                "image": unit.hasLargeShadow ? require("@frog/source/assets/images/apocalypse-tactics/units/shadow_lg.png").default : require("@frog/source/assets/images/apocalypse-tactics/units/shadow.png").default,
                "anchor": {"x": "50%", "y": "100%"},
                "position": {"x": 0, "y": 0},
                // "blendmode": "cool",
            },
            {
                "key": "Sprite",
                "image": unit.image,
                "anchor": {"x": "50%", "y": "100%"},
                "position": {"x": 0, "y": 0},
                "isFlipped": unit.isFlipped,
                // "tint": UnitTint(stage, unit),
                // "outline": UnitOutline(stage, unit),
                // "overrides": {
                //     "hovered": {
                //         "color": "#e6db33",
                //     },
                // }
            },
        ]
    }
}

function Shop(stage) {
    if(Navigation.state.section != "shop") {
        return
    }
    return {
        "width": "100%",
        "height": "100%",
        "_": [
            {
                "position": {"x": 0, "y": 0},
                "color": "#000",
                // "opacity": "50%",
                "width": "50%",
                "height": "100%",
            },
            {
                "position": {"x": "50%", "y": 0},
                "width": "50%",
                "height": "100%",
                "events": {
                    "cursordown": function(event) {
                        Navigation.state.section = undefined
                    }
                },
            },
            {
                "position": {
                    "x": 3,
                    "y": 3,
                },
                "_": [
                    Text("Welcome back, gaurd'ners!! What would you like to buy?")
                ],
            },
            Object.values(App.game.player.party.units).map((unlockable, index) => {
                const unlockableUnit = getReferencedUnit(unlockable)
                return {
                    "position": {
                        "x": 3,
                        "y": 20 + 13 * index,
                    },
                    "_": [
                        Text((unlockableUnit.type == "plant" ? "Seeds:" : "Ally:") + " " + unlockableUnit.name + Repeat(" ", 20 - unlockableUnit.name.length) + unlockable.points + " point" + (unlockable.crops != 1 ? "s" : "") + "")
                    ],
                    "opacity": unlockable.isUnlocked ? 0.5 : 1,
                    "events": {
                        "cursordown": (event) => {
                            if(unlockable.isUnlocked != true
                            && App.game.player.score >= unlockable.points) {
                                App.game.player.score -= unlockable.points
                                unlockable.isUnlocked = true
                                Ink.set(unlockableUnit.classname + "_unlocked", true)
                            }
                        }
                    },
                }
            }),
        ]
    }
}

function SplashScreen(stage) {
    return {
        "key": "SplashScreen",
        "width": "100%",
        "height": "100%",
        "events": {
            "cursordown": (event) => {
                Navigation.go("/game")
            }
        },
        "_": [
            {
                "opacity": Math.floor(timer.s * 2) % 2 == 0 ? 1 : 0,
                "x": "50%",
                "y": "50%",
                "anchor": {"x": "50%", "y": "50%"},
                "_": [
                    Text("Loaded! Click to begin."),
                ]
            }
        ]
    }
}

import {getImageFromAnimation} from "@frog/source/juice/utility/getFrameFromAnimation.js"

let clicktime = undefined
function TitleScreen(stage) {
    const hasJustClicked = (window.performance.now() - clicktime) < 1000
    return {
        "key": "TitleScreen",
        "width": "100%",
        "height": "100%",
        "events": {
            "cursordown": (event) => {
                Audiomix.trigger("Start")
                if(hasJustClicked) return
                clicktime = window.performance.now()
                window.setTimeout(() => {
                    Navigation.go("/game/encounters/first_day")
                }, 1000)
            }
        },
        "_": [
            {
                "x": "50%",
                "y": "50%",
                "anchor": {"x": "50%", "y": "50%"},
                "image": require("@frog/source/assets/images/apocalypse-tactics/ui/title.png").default,
            },
            {
                "x": "50%",
                "y": "75%",
                "anchor": {"x": "50%", "y": "50%"},
                "opacity": Math.floor(timer.s * (hasJustClicked ? 10 : 1)) % 2 == 0 ? 1 : 0,
                "_": [
                    Text("Click to Play")
                ]
            }
        ]
    }
}

import chapters from "@frog/source/data/encounters/chapters.js"

function ChapterSelectScreen(stage) {
    return {
        "key": "ChapterSelectScreen",
        "width": "100%",
        "height": "100%",
        "_": Object.values(chapters)
            .filter((chapter) => chapter.isInChapterSelect)
            .sort((a, b) => a.isInChapterSelect - b.isInChapterSelect)
            .map((chapter, index) => {
            return {
                "position": {
                    "x": 0,
                    "y": 13 * index,
                },
                "_": [
                    Text(chapter.name)
                ],
                "events": {
                    "cursordown": (event) => {
                        Navigation.go("/game/encounters/" + chapter.slug)
                    }
                },
            }
        })
    }
}

function CombatEncounterScreen(stage) {
    return {
        "key": "CombatEncounterScreen",
        "width": "100%",
        "height": "100%",
        "_": [
            Stage(stage),
            Interface(stage),
            Particles(stage, "screenspace"),
            {
                "stack": -99,
                "anchor": {"x": 0, "y": 0},
                "position": {"x": 0, "y": 0},
                "tint": App.game.encounter.backgroundTint,
                "image": App.game.encounter.background,
            },
            {
                "stack": 99,
                "anchor": {"x": 0, "y": 0},
                "position": {"x": 0, "y": 0},
                "image": App.game.encounter.foreground,
            },
        ]
    }
}

function CreditsScreen(stage) {
    return {
        "key": "CreditsScreen",
        "width": "100%",
        "height": "100%",
        "color": "hotpink",
        "events": {
            "cursordown": function(event) {
                Navigation.go("/game/town")
            }
        },
        "_": [
            {
                "stack": -99,
                "anchor": {"x": "50%", "y": "50%"},
                "position": {"x": "50%", "y": "50%"},
                // "tint": {
                //     "color": "#6699CC",
                //     "intensity": 0.5
                // },
                "image": require("@frog/source/assets/images/apocalypse-tactics/environment/backgrounds/background-0-full.png").default,
            },
            {
                "key": "Contents",
                "x": "50%",
                "width": 350 / 2,
                "anchor": {"x": "50%"},
                "y": Math.min(Math.max(-1 * (window.performance.now() - (Navigation.state.time)) / 75, -560), 0),
                "_": [
                    {
                        "x": "50%",
                        "y": 140,
                        "width": 512,
                        "anchor": {"x": "50%", "y": "50%"},
                        "image": require("@frog/source/assets/images/apocalypse-tactics/logo.png").default,
                    },
                    {
                        "x": 0,
                        "y": (255 / 2) + 4 + 80 + 70 + 2,
                        "_": [
                            {
                                "position": {"x": 56 - 32, "y": 0 * 16 + 4},
                                "anchor": {"x": "50%", "y": "25%"},
                                "image": getImageFromAnimation(units["class:donna"].images.sprites["hover"], getTime().ms),
                            },
                            {
                                "position": {"x": 56+100, "y": 3 * 16 + 4},
                                "anchor": {"x": "50%", "y": "25%"},
                                "image": getImageFromAnimation(units["class:jasmine"].images.sprites["hover"], getTime().ms),
                            },
                            {
                                "position": {"x": 56-32, "y": 6 * 16 + 4},
                                "anchor": {"x": "50%", "y": "25%"},
                                "image": getImageFromAnimation(units["class:z"].images.sprites["hover"], getTime().ms),
                            },
                            {
                                "position": {"x": 56+100, "y": 9 * 16 + 4},
                                "anchor": {"x": "50%", "y": "25%"},
                                "image": getImageFromAnimation(units["class:blitz"].images.sprites["hover"], getTime().ms),
                            },
                            {
                                "position": {"x": 56-32, "y": 12 * 16 + 4},
                                "anchor": {"x": "50%", "y": "50%"},
                                "image": getImageFromAnimation(units["class:spider1"].images.sprites["idle"], getTime().ms),
                            },
                            Credit({
                                "name": "Kieran Lampert",
                                "role": "Character Art",
                                "position": {"x": 56, "y": 0 * 16 + 4}
                            }),
                            Credit({
                                "name": "Tania Pavlisak",
                                "role": "Environment Art",
                                "position": {"x": 56, "y": 3 * 16 + 4}
                            }),
                            Credit({
                                "name": "Paxton",
                                "role": "Narrative Design",
                                "position": {"x": 56, "y": 6 * 16 + 4}
                            }),
                            Credit({
                                "name": "Steven Garcia",
                                "role": "Music, Sound Design",
                                "position": {"x": 56, "y": 9 * 16 + 4}
                            }),
                            Credit({
                                "name": "Andrew Goodenough",
                                "role": "Production, Development",
                                "position": {"x": 56, "y": 12 * 16 + 4}
                            }),
                            {
                                "position": {"x": 56, "y": (26-3) * 16 + 4},
                                "_": [Text("Thanks for playing!!")]
                            }
                        ]
                    }
                ]
            }
        ]
    }
}

function Credit(credit) {
    return {
        "position": credit.position,
        "_": [
            {
                "position": {"x": 0, "y": 0 * 16},
                "_": [Text(credit.name)],
            },
            {
                "position": {"x": 0, "y": 1 * 16},
                "_": [Text(credit.role)],
            },
        ]
    }
}
